import { observer } from 'mobx-react-lite'
import { useFlags } from 'launchdarkly-react-client-sdk'
import GeneralSection from './sections/GeneralSection'
import SummarySection from './sections/SummarySection'
import ReferralsSection from './sections/ReferralsSection'
import MedicationsSection from './sections/MedicationsSection'
import AllergiesSection from './sections/AllergiesSection'
import MedicalAndFamilyHistorySection from './sections/MedicalAndFamilyHistorySection'
import LifestyleSection from './sections/LifestyleSection'
import addDotToICDCode from 'util/addDotToICDCode'
import DetailsValue from './common/DetailsValue'
import MbcSection from './sections/MbcSection'
import PrescriptionsSection from './sections/PrescriptionsSection'
import VisitTicketDetails from 'components/tickets/VisitTicketDetails'
import DetailsSection from './common/DetailsSection'
import { isFlaggedOn } from 'components/FeatureFlag'

type VisitDetailsProps = {
  // TODO - improve type
  visit: any
  parentVisit: any
  editable?: boolean
  memberMode?: boolean
  providerMode?: boolean
}

const VisitDetails = ({ visit, memberMode, providerMode, parentVisit, editable }: VisitDetailsProps) => {
  const { isSuccess, dxs, pendingVisitId } = visit || {}
  const flags = useFlags()
  const isCrisisNotePhase2Enabled = isFlaggedOn('tcCrisisNotePhase2', flags)

  const displayDiagnosis = !!dxs?.length && (
    <div className="flex flex-col gap-2">
      {dxs.map(({ id, code, description }) => (
        <p key={id}>
          {addDotToICDCode(code)} {description}
        </p>
      ))}
    </div>
  )

  return (
    <div className="flex flex-col gap-5">
      <DetailsValue label="Diagnosis" value={displayDiagnosis} />
      {!!(memberMode || providerMode) && (
        <>
          <GeneralSection visit={visit} />
          {!isSuccess && <MbcSection visit={visit} />}
        </>
      )}
      <SummarySection visit={visit} parentVisit={parentVisit} />
      <ReferralsSection visit={visit} />
      {!!memberMode && !isSuccess && (
        <>
          <AllergiesSection visit={visit} />
          <MedicationsSection visit={visit} />
          <PrescriptionsSection visit={visit} editable={!!editable} />
          <MedicalAndFamilyHistorySection visit={visit} />
          <LifestyleSection visit={visit} />
        </>
      )}
      {isCrisisNotePhase2Enabled && !isSuccess && !!pendingVisitId && (
        <DetailsSection title="Tickets">
          <VisitTicketDetails visitId={pendingVisitId} />
        </DetailsSection>
      )}
    </div>
  )
}

export default observer(VisitDetails)
